export enum ChapterState {
  Pending = "pending",
  Current = "current",
  Done = "done",
}

export enum ChapterName {
  Profil = "profil",
  Foyer = "foyer",
  Logement = "logement",
  Revenus = "revenus",
  Projets = "projets",
  Recapitulatif = "recapitulatif",
  Resultats = "resultats",
}

export enum ChapterLabel {
  MonProfil = "Mon profil",
  MonFoyer = "Mon foyer",
  MonLogement = "Mon logement",
  MesRevenus = "Mes revenus",
  MesProjets = "Mes projets",
  Recapitulatif = "Récapitulatif",
  Resultats = "Mes résultats",
}
